function SquareIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" className="min-w-[12px]">
      <rect
        fill="white"
        x="6"
        y="6"
        width="14"
        height="14"
        strokeWidth="2"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SquareIcon;
